import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotifyService {

  constructor(private messageService: MessageService) {}

  emitSuccess(message: string) {
    this.messageService.add({ severity: 'success', summary: 'ATENÇÃO!', detail: message });
  }

  emitError(message: string) {
    this.messageService.add({ severity: 'error', summary: 'ERRO!', detail: message });
  }

  emitWarn(message: string, title?: string, sticky ?: boolean , closable?: boolean) {
    this.messageService.add({ sticky , closable ,severity: 'warn', summary: title ?? 'ATENÇÃO!', detail: message });
  }

  saveSuccess(message = 'Registro inserido.') {
    this.messageService.add({ severity: 'success', summary: 'SUCESSO!', detail: message });
  }

  editSuccess() {
    this.messageService.add({ severity: 'success', summary: 'SUCESSO!', detail: 'Registro editado.' });
  }

  deleteSuccess() {
    this.messageService.add({ severity: 'success', summary: 'SUCESSO!', detail: 'Registro removido.' });
  }

  inactivateSuccess() {
    this.messageService.add({ severity: 'success', summary: 'SUCESSO!', detail: 'Registro inativado.' });
  }

  closeAll() {
    this.messageService.clear();
  }

  emitInfo(message: string){
    this.messageService.add({ severity: 'info', summary: 'INFO!' , detail: message });
  }
}
